import http from '../../http-common'

export default class UserPurchaseService {
  protected subdomain = 'user-purchase'
  private readonly locationId: string

  constructor(locationId: string) {
    this.locationId = locationId
  }

  private get endpoint() {
    return `/locations/${this.locationId}/${this.subdomain}`
  }

  findAll(params?: any): Promise<[]> {
    return http
      .get(`${this.endpoint}`, {
        params
      })
      .then(res => res.data)
  }

  getAllProducts(params?: any): Promise<[]> {
    return http
      .get(`${this.endpoint}/get-all-products`, {
        params
      })
      .then(res => res.data)
  }

  checkIfProductBought(productId: string): Promise<any> {
    return http
      .get(`${this.endpoint}/check-product-purchase/${productId}`)
      .then(res => res.data)
  }
}
